<template>
    <v-progress-linear :value="value" :color="color" :height="small ? 16 : 36">
        <template v-slot:default="{ value }">
            <strong :class="small ? '' : 'title'">{{ Math.ceil(value) }}%</strong>
        </template>
    </v-progress-linear>
</template>

<script>
export default {
    props: {
        value: { required: true },
        small: { default: false },
    },
    computed: {
        color() {
            if (this.value >= 100) {
                return 'green';
            }
            if (this.value >= 90) {
                return 'green lighten-1';
            }
            if (this.value >= 70) {
                return 'lime';
            }
            if (this.value >= 50) {
                return 'teal lighten-1';
            }
            if (this.value >= 30) {
                return 'yellow';
            }
            if (this.value >= 20) {
                return 'orange';
            }
            if (this.value > 0) {
                return 'red';
            }
            return 'grey';
        }
    }
}
</script>

<style lang="scss" scoped></style>